import { render } from "./Introduction.vue?vue&type=template&id=e08cfa24&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=e08cfa24&lang=scss&scoped=true"

import exportComponent from "/Users/wangwangxinkai/Documents/PBM/tianke-1/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08cfa24"]])

export default __exports__